// Custom Logo Switcher JavaScript - Enhanced Version
document.addEventListener('DOMContentLoaded', function() {
  function switchLogo() {
    const whiteLogo = 'https://cdn.shopify.com/s/files/1/0575/5856/4913/files/sixteenine_logo_white.png?v=1757673832';
    const blackLogo = 'https://cdn.shopify.com/s/files/1/0575/5856/4913/files/sixteenine_logo_black.png?v=1757674156';
    
    // Get current page template
    const bodyClasses = document.body.className;
    const isHomepage = bodyClasses.includes('template-index') || 
                       window.location.pathname === '/' || 
                       window.location.pathname === '';
    const isCheckout = bodyClasses.includes('template-checkout') || 
                       bodyClasses.includes('checkout') || 
                       window.location.pathname.includes('/checkout') ||
                       window.location.pathname.includes('/checkouts');
    
    // Determine which logo to use
    let logoToUse = blackLogo; // Default to black logo
    
    if (isHomepage || isCheckout) {
      logoToUse = whiteLogo; // Use white logo on homepage and checkout
      console.log('Using white logo for homepage/checkout');
    } else {
      console.log('Using black logo for other pages');
    }
    
    // Find all logo images - be more thorough
    const logoSelectors = [
      '.header__heading-logo',
      '.header__heading-logo-wrapper img',
      'img.header__heading-logo',
      '.header__heading-link img',
      '.header img[alt*="logo"]',
      '.header img[alt*="Logo"]',
      '.header img[alt*="LOGO"]',
      '.header img[alt*="sixteenine"]',
      '.header img[alt*="Sixteenine"]',
      '.header img[alt*="SIXTEENINE"]'
    ];
    
    logoSelectors.forEach(function(selector) {
      const logos = document.querySelectorAll(selector);
      logos.forEach(function(logo) {
        if (logo && logo.tagName === 'IMG') {
          // Update all image properties
          logo.src = logoToUse;
          logo.srcset = logoToUse + ' 1x, ' + logoToUse + ' 2x';
          
          // Update data attributes
          if (logo.dataset) {
            logo.dataset.src = logoToUse;
            logo.dataset.srcset = logoToUse + ' 1x, ' + logoToUse + ' 2x';
          }
          
          // Force update by removing and re-adding the image
          const newLogo = logo.cloneNode(true);
          newLogo.src = logoToUse;
          newLogo.srcset = logoToUse + ' 1x, ' + logoToUse + ' 2x';
          logo.parentNode.replaceChild(newLogo, logo);
        }
      });
    });
    
    // Handle picture elements
    const pictureElements = document.querySelectorAll('picture');
    pictureElements.forEach(function(picture) {
      if (picture.closest('.header')) {
        const sources = picture.querySelectorAll('source');
        sources.forEach(function(source) {
          source.srcset = logoToUse;
        });
        const img = picture.querySelector('img');
        if (img) {
          img.src = logoToUse;
          img.srcset = logoToUse + ' 1x, ' + logoToUse + ' 2x';
        }
      }
    });
  }
  
  // Run immediately
  switchLogo();
  
  // Run again after a short delay to catch any dynamically loaded content
  setTimeout(switchLogo, 100);
  setTimeout(switchLogo, 500);
  setTimeout(switchLogo, 1000);
});

// Also handle dynamic page changes
window.addEventListener('popstate', function() {
  location.reload();
});